<script lang="ts" setup>
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { logCompletion } from '@bosca/analytics-client-browser'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Loading from '~/assets/images/loading.svg?component'

const email = ref<HTMLInputElement | null>(null)
const password = ref<HTMLInputElement | null>(null)
const disabled = ref(false)
const error = ref<string | null>(null)

const props = defineProps<{
  popup?: boolean | undefined
}>()

async function doLogin() {
  disabled.value = true
  try {
    const auth = getAuth()
    await signInWithEmailAndPassword(auth!, email.value!.value, password.value!.value)
    window.dispatchEvent(new Event('refresh-header'))
    if (props.popup) {
      window.dispatchEvent(new Event('hide-auth-prompt'))
      document.location.href += '?_signedIn=true'
    }
    else {
      document.location = '/'
    }
    await logCompletion({
      id: 'signin',
      type: 'button',
      content: [],
      extras: {},
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  catch (e: any) {
    error.value = e.message.replace('Firebase: ', '').replace(/\(.*\)\./g, '')
    let code = 'unknown'
    if (typeof e.code === 'string') {
      code = e.code
    }
    await logCompletion({
      id: 'signin',
      type: 'button',
      content: [],
      extras: { error: 'true', message: error.value?.toString() || '', code: code },
    })
    console.error('signin failed', e)
  }
  finally {
    if (error.value) {
      disabled.value = false
    }
    else {
      setTimeout(() => disabled.value = false, 3000)
    }
  }
}

function showSignUp() {
  window.dispatchEvent(new Event('show-auth-prompt-signup'))
}

function hideAuth() {
  window.dispatchEvent(new Event('hide-auth-prompt'))
}
</script>

<template>
  <div class="px-4">
    <AuthenticationHeader />
    <AuthenticationNavigation :popup="popup" />
    <div class="grid grid-cols-1 max-w-[675px] m-auto mt-8 text-center">
      <AuthenticationThirdPartyLogin :popup="popup" />
    </div>
    <AuthenticationDivider />
    <div class="grid grid-cols-1 max-w-[675px] m-auto mt-8 text-center">
      <input
        ref="email"
        :placeholder="$t('email')"
        type="text"
        class="border border-gray-400 p-2 mb-4 text-black rounded-lg"
      >
      <input
        ref="password"
        :placeholder="$t('password')"
        type="password"
        class="border border-gray-400 p-2 mb-8 text-black rounded-lg"
      >
      <PButton
        id="signin"
        class="bg-blurple-600 text-white hover:bg-blurple-950 p-2 mb-8 flex justify-center items-center h-10 rounded-lg"
        :disabled="disabled"
        :click="doLogin"
      >
        <Loading
          v-if="disabled"
          class="stroke-white w-4 h-4 animate-spin"
        />
        <span v-else>
          {{ $t('signin') }}
        </span>
      </PButton>
      <UAlert
        v-if="error"
        class="rounded-none mb-2"
        color="red"
        variant="subtle"
        :title="error || ''"
      />
      <div class="text-black font-sans text-sm font-light leading-6 px-6 mt-4">
        <PLink
          id="forgotpassword"
          to="/forgotpassword"
          :click="hideAuth"
          class="ms-1 text-blurple-600 underline hover:no-underline"
        >
          {{ $t('forgotPassword') }}
        </PLink>
      </div>
      <div class="text-black font-sans text-sm font-light leading-6 px-6 mt-2">
        {{ $t('newToPassionEquip') }}
        <PLink
          v-if="popup"
          id="signup"
          href="#"
          :click="showSignUp"
          class="ms-1 text-blurple-600 hover:no-underline underline"
        >
          {{ $t('createProfile') }}
        </PLink>
        <PLink
          v-else
          id="signup"
          to="/signup"
          :click="hideAuth"
          class="ms-1 text-blurple-600 hover:no-underline underline"
        >
          {{ $t('createProfile') }}
        </PLink>
      </div>
    </div>
  </div>
</template>
